module.exports = __webpack_public_path__ + "static/media/ic_hz_white.d954c0dc.svg";